import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { PushHighScoreStyle } from './../../styles'
import Router from '../../services/Router'

class PushQuizz extends Component {
  state = {
    hasScore: false,
    fake: [],
  }

  componentDidMount() {
    this.getLast()
  }

  componentWillReceiveProps({ menu }){
    if ( menu.challenge.rankings !==  this.props.menu.challenge.rankings) this.getLast()
  }

  getLast = () => {
    const last = this.props.menu.challenge.rankings.length < 10 ? 10 - this.props.menu.challenge.rankings.length : 0
    const fake = []
    if (last !== 0){
      for (let i = 0; i < last; i++) {
        fake.push(i)
      }
      this.setState({ fake })
    }
  }

  render() {
    const { rankings } = this.props.menu.challenge
    const { fake } = this.state
    return (
      <div className={`push-high-score ${PushHighScoreStyle}`}>
        <h3>High Score</h3>
        <div className="ranking-table">
          <div className="first">
           {
              rankings.slice(0,3).map((ranking, index) => (
                <div className={`ranking-line flex ${ ranking.score && ranking.current ? 'current current--menu': ''}`} key={index}>
                  <span className="number">
                    { index + 1 }
                    <sup>
                      {
                        index === 0 ? 'st' : index === 1 ? 'nd' : 'rd'
                      }
                    </sup>
                  </span>
                  <span className="name"> {ranking.score ? ranking.name : '-'} </span>
                  <span className="localisation"> {ranking.score ? ranking.city : '-'} </span>
                  <span className="score"> {ranking.score ? ranking.score : '-'} </span>
                </div>
              ))
            }
          </div>
          <div className="last">
          {
              rankings.slice(3, rankings.length).map((ranking, index) => (
                <div className={`ranking-line flex ${ ranking.score && ranking.current ? 'current current--menu': ''}`} key={index}>
                  <span className="number">
                    { index + 4 }
                  </span>
                  <span className="name"> {ranking.score ? ranking.name : '-'} </span>
                  <span className="localisation"> {ranking.score ? ranking.city : '-'} </span>
                  <span className="score"> {ranking.score ? ranking.score : '-'} </span>
                </div>
              ))
            }
            {
              fake.length > 0 && fake.map((index) => (
                <div className='ranking-line flex' key={index}>
                  <span className="number">
                    { rankings.length + index + 1 }
                  </span>
                  <span className="name"> - </span>
                  <span className="localisation"> - </span>
                  <span className="score"> - </span>
                </div>
              ))
            }
          </div>
        </div>
       
        <Link to={Router.ranking.exactPath} className="link">Check the general ranking</Link>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    menu: Session.menu,
  })
)(PushQuizz)



// WEBPACK FOOTER //
// ./src/components/Challenge/PushHighScore.js